import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'no_certified_fire_resistant_doors_no_fire_resistant'

export const dataPointDefinition = {
  retracedId: 'no_certified_fire_resistant_doors_no_fire_resistant',
  name: 'No certified fire-resistant doors and no fire-resistant walls are in use in production units',
  description: '',
  meta: {
    slcpMeta: {
      key: 'hs-eme-23x',
      number: 'HS-EME-10-2',
      dataType: 'boolean',
      masterType: 'Question',
      multiSelectKey: 'hs-eme-21',
      optionList: 'ms',
      versionImported: '1.7.0',
      verificationTypeReq: 'base-verf',
      verificationSelectionOptList: 'verf-a-list',
      nonComOptionList: 'lf',
      nonCompliance: '',
      humanShowHide: '[2]',
      machineShowHide: '[2]',
      completionCondition: 'any ms',
    },
  },
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [
    {
      id: 'ms',
      name: 'ms',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'hs-eme-23x', version: '1.7.0', provider: 'slcp'}],
  sortingId: 30700,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
